var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagBosniaAndHerzegovina(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15050)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0C10.3269 0 5.34375 2.95269 2.50275 7.40494L24.2002 29.7406C28.8716 26.9467 32 21.8389 32 16C32 7.1635 24.8365 0 16 0Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 15.9999C32 11.8485 30.4189 8.06677 27.826 5.22314V26.7767C30.4189 23.933 32 20.1513 32 15.9999Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9868 30.1169L21.6628 30.1159L22.1798 28.5215L22.6986 30.1152L23.5392 30.1147C24.0547 29.8388 24.5533 29.5355 25.033 29.2067L2.79306 6.9668C2.42656 7.50155 2.09231 8.05992 1.79175 8.63867L1.98937 9.24567L3.66531 9.24461L2.31006 10.2305L2.82894 11.8242L1.47244 10.84L0.663375 11.4285C0.232063 12.877 0 14.4113 0 15.9999C0 24.8364 7.1635 31.9999 16 31.9999C17.8682 31.9999 19.6614 31.6791 21.3281 31.0904L19.9868 30.1169ZM3.56869 15.3042L4.08556 13.71L2.72919 12.7256L4.40513 12.7245L4.92206 11.1302L5.44094 12.7239L7.11688 12.7229L5.76156 13.7088L6.28044 15.3025L4.92394 14.3182L3.56869 15.3042ZM7.02025 18.7825L7.53713 17.1882L6.18075 16.2039L7.85669 16.2028L8.37362 14.6085L8.8925 16.2022L10.5684 16.2011L9.21319 17.187L9.73206 18.7807L8.37556 17.7965L7.02025 18.7825ZM10.4718 22.2607L10.9886 20.6665L9.63225 19.6821L11.3082 19.681L11.8251 18.0867L12.344 19.6804L14.0199 19.6794L12.6647 20.6653L13.1836 22.259L11.8271 21.2746L10.4718 22.2607ZM15.2786 24.753L13.9233 25.739L14.4401 24.1447L13.0837 23.1604L14.7597 23.1593L15.2767 21.565L15.7956 23.1587L17.4715 23.1576L16.1162 24.1435L16.6351 25.7372L15.2786 24.753ZM17.3748 29.2172L17.8917 27.623L16.5353 26.6386L18.2113 26.6375L18.7282 25.0432L19.2471 26.6369L20.923 26.6359L19.5678 27.6218L20.0866 29.2155L18.7301 28.2311L17.3748 29.2172Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15050"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagBosniaAndHerzegovina);
export default __webpack_public_path__ + "static/media/flag_bosnia_and_herzegovina.d489fe8dc71c486a44658e6f3e9460a6.svg";
export { ForwardRef as ReactComponent };